<template>
  <div>
    <!-- Tabs for Overview, Consignment Orders, Allocations Requests -->
    <a-tabs
      v-model="activeStockTab"
      style="margin-top: 32px"
      @change="onStockTabChange"
    >
      <a-tab-pane key="1" tab="Overview">
        <StockOverview :sellerId="sellerId" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="Consignment Orders">
        <ConsignmentOrders :sellerId="sellerId" />
      </a-tab-pane>
      <a-tab-pane key="3" tab="Allocations Requests">
        <SellerAllocationsTab :sellerId="sellerId" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import StockOverview from "./StockOverview.vue";
import ConsignmentOrders from "./ConsignmentOrders.vue";
import SellerAllocationsTab from "./SellerAllocationsTab.vue";

export default {
  name: "SellerStockTab",
  components: { StockOverview, ConsignmentOrders, SellerAllocationsTab },
  props: {
    sellerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeStockTab: this.$route.query.subTab || "1",
    };
  },
  watch: {
    // Watch for route changes to sync tab
    '$route.query.subTab'(newVal) {
      if (newVal && newVal !== this.activeStockTab) {
        this.activeStockTab = newVal;
      }
    },
  },
  methods: {
    onStockTabChange(newKey) {
      // Update the route query with the new tab
      this.$router.replace({
        query: { ...this.$route.query, subTab: newKey },
      }).catch(() => {});
      this.activeStockTab = newKey;
    },
  },
};
</script>
